import z from 'zod';

export const progressStudySchema = z.object({
  /** Topic name */
  topic: z.string(),
  /** Array of study titles completed for this topic */
  title: z.array(z.string()),
  /** Whether this topic is marked as done */
  done: z.boolean(),
  /** Progress percentage as a number between 0 and 1 */
  progress: z.number().min(0).max(1).optional(),
});

export interface ProgressStudy extends z.infer<typeof progressStudySchema> {}
